var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseCreated(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.5,
    height: 66.5,
    viewBox: "0 0 66.5 66.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M57.17-8.428a9.287,9.287,0,0,1,12.974,0,10.021,10.021,0,0,1,2.595,5l3.707-.556a12.2,12.2,0,0,0-3.522-7.043,13.09,13.09,0,0,0-18.349,0L50.5-15.1,49.2-3.238l11.862-1.3Z",
    transform: "translate(-49.2 15.1)",
    fill: "#2b3e5b",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M77.346-7.3,65.484-6,69.376-2.11a9.287,9.287,0,0,1-12.974,0,10.021,10.021,0,0,1-2.595-5L50.1-6.559A12.2,12.2,0,0,0,53.622.484,12.454,12.454,0,0,0,62.7,4.191,12.911,12.911,0,0,0,71.786.484l4.078,4.077Z",
    transform: "translate(-50.1 7.3)",
    fill: "#2b3e5b",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3025",
    "data-name": "Group 3025",
    transform: "translate(-1345 -108.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498",
    transform: "translate(1159.5 -429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1296",
    "data-name": "Group 1296",
    transform: "translate(185.5 537.268)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_38",
    "data-name": "Ellipse 38",
    cx: 33.25,
    cy: 33.25,
    r: 33.25,
    fill: "#eaeef5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2946",
    "data-name": "Group 2946",
    transform: "translate(1363.602 128.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2896",
    "data-name": "Group 2896",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M44.2-20.1h45.78V10.3H44.2Z",
    transform: "translate(-53.468 10.833)",
    fill: "#2b3e5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2897",
    "data-name": "Group 2897",
    transform: "translate(1.669 14.457)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M45.1-12.3h45.78V18.1H45.1Z",
    transform: "translate(-54.368 3.033)",
    fill: "#2b3e5b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseCreated);
export default __webpack_public_path__ + "static/media/caseCreated.20ecb74bea4067ae982b5074f656605b.svg";
export { ForwardRef as ReactComponent };